import { Card, CardContent } from "@/components/ui/card";
import { ThemeToggle } from "@/components/theme/ThemeToggle";
import { LanguageSwitcher } from "@/components/layout/LanguageSwitcher";
import { LoginForm } from "@/components/auth/LoginForm";
import { LoginHeader } from "@/components/auth/LoginHeader";
import { BrandLogo } from "@/components/auth/BrandLogo";
import { AuthRedirector } from "@/components/auth/AuthRedirector";
import { AppVersionTag } from "@/components/common/AppVersionTag";
import { useAuth } from "@/contexts/AuthContext";

const Login = () => {
  const { loading } = useAuth();

  if (loading) return <div>Chargement...</div>;

  return (
    <div className="h-screen overflow-hidden flex flex-col">
      {/* Fixed header */}
      <div className="fixed top-0 left-0 right-0 z-50 h-16-safe bg-background border-b border-border flex items-center justify-end px-4">
        <div className="flex items-center gap-4">
          <ThemeToggle />
          <LanguageSwitcher />
        </div>
      </div>
      
      {/* Main content */}
      <div className="flex-1 flex flex-col items-center justify-center p-4 pt-[calc(env(safe-area-inset-top)+5rem)] pb-[calc(env(safe-area-inset-bottom)+1rem)]">
        <BrandLogo />
        
        <Card className="w-full max-w-md">
          <LoginHeader />
          <CardContent>
            <LoginForm />
          </CardContent>
        </Card>

        <AppVersionTag className="mt-6" />
      </div>
      
      <AuthRedirector />
    </div>
  );
};

export default Login;
